import { getPhysicalDamageVehicles } from "@shared/physical-damage-vehicles";
import type {
  PhysicalDamageVehicleSelection,
  Policy,
  PolicyCoverages,
  PolicyVehicle,
} from "@shared/schema";
import { VehicleSection } from "./PhysicalDamageVehicleSection";

interface Props {
  policy: Policy;
}

export function PhysicalDamageVehicleList({ policy }: Props) {
  const { powerUnits, trailers } = getPhysicalDamageVehicles({
    vehicles: policy.vehicles as PolicyVehicle[] | null,
    trailers: policy.trailers as PolicyVehicle[] | null,
    coverages: policy.coverages as PolicyCoverages | null,
    // CSR-1144: honour the agent's explicit selection when curated; falls back
    // to deductible inference for never-curated policies.
    physicalDamageVehicles:
      policy.physicalDamageVehicles as PhysicalDamageVehicleSelection | null,
  });

  return (
    <div
      className="mt-3 space-y-4 pt-3 border-t border-border"
      data-testid="physical-damage-vehicle-list"
    >
      <VehicleSection
        title="POWER UNITS"
        rowLabel="Power Unit"
        vehicles={powerUnits.covered}
        total={powerUnits.total}
        testId="physical-damage-vehicle-list-power-units"
      />
      <VehicleSection
        title="TRAILERS"
        rowLabel="Trailer"
        vehicles={trailers.covered}
        total={trailers.total}
        testId="physical-damage-vehicle-list-trailers"
      />
    </div>
  );
}
